import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import HowWeWork from "./pages/HowWeWork";
import Contact from "./pages/Contact";
import SmoothScroll from "./components/SmoothScroll";
import AnalyticsPageViews from "./components/AnalyticsPageViews";
import { Toaster } from "./components/ui/sonner";
import { initGA } from "./utils/analytics";

function App() {
  useEffect(() => {
    // Initialize Google Analytics
    initGA();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <SmoothScroll>
          <AnalyticsPageViews />
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/how-we-work" element={<HowWeWork />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
          <Footer />
          <Toaster />
        </SmoothScroll>
      </BrowserRouter>
    </div>
  );
}

export default App;
